import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useParams, generatePath } from 'react-router';
import { useToasts } from 'react-toast-notifications';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import ja from 'date-fns/locale/ja';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
registerLocale('ja', ja);

const BenefitLotteryTicket = (props) => {
  const { siteId, mallId } = useParams();
  const { user } = props;
  const [benefitLotteryTicketData, setBenefitLotteryTicketData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();
  const history = useHistory();
  const [shopGroupON, setShopGroupONValues] = useState([]);
  const [shopGroupOFF, setShopGroupOFFValues] = useState([]);
  const [shopGroupMaster, setShopGroupMaster] = useState([]);
  const [mallData, setMallData] = useState(null);
  const [ticketData, setTicketData] = useState(null);
  // const imageRef = useRef();


  // const generateYearMonthOptions = () => {
  //   const options = [];
  //   const now = moment();
  //   for (let i = 0; i < 20; i++) {
  //     const ym = now.clone().add(i, 'months').format('YYYYMM');      
  //     options.push({ value: ym, label: ym });
  //   }
  //   return options;
  // };
  // const yearMonthOptions = generateYearMonthOptions();

  const [benefitLotteryTicketValues, setBenefitLotteryTicketValues] = useState({
    benefit_lottery_ticket_id: "",
    lottery_start: null,
    lottery_end: null,
    benefit_lottery_ticket_title: "",
    benefit_lottery_ticket_summary: "",
    benefit_lottery_ticket_detail: "",
    benefit_lottery_ticket_image_url: '',
    benefit_lottery_ticket_detail_image_url: '',
    notice_lottery_image_url: '',
    expiry: "",
    limit_count: null,
    min_amount: null,
    receiving_type: constClass.RECEIVING_TYPE.TICKET_DELIVERY,
    ticket_id: null,
    point: null,
    distribution_point_mall_flag: constClass.FLAG.OFF,
    point_mall_id: null,
    push_datetime: null,
    uploadfile: null,
    uploadfiletype: null,
    deletefile: null,
    uploadfile2: null,
    uploadfiletype2: null,
    deletefile2: null,
    uploadfile3: null,
    uploadfiletype3: null,
    deletefile3: null,
    upd_date: "",
    notice_title: '',
    notice_alt_text: '',
    notice_detail: '',
    year_month: []
  });

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    try {
      // 先にAPI実行
      var resdata = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/${siteId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;
      setBenefitLotteryTicketData(resdata);

      const shopGroup = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/${siteId}/${mallId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      })).data.map((val) => { return { value: val.shop_group_id, label: val.shop_group_name }; });
      setShopGroupMaster(shopGroup);

      const mallData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${siteId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      })).data;
      setMallData(mallData);

      var ticketData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      })).data;
      setTicketData(ticketData.filter(item => item.ticket_type === constClass.TICKET_TYPE.FREE && item.limit_issue_flag === constClass.FLAG.ON));
    } catch (err) {
      console.log(err);
    }
  }, [siteId, mallId]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);


  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    if (name === "distribution_point_mall_flag" && value === constClass.FLAG.ON) {
      setBenefitLotteryTicketValues({ ...benefitLotteryTicketValues, [name]: value, point_mall_id: null });
    } else {
      setBenefitLotteryTicketValues({ ...benefitLotteryTicketValues, [name]: value });
    }
  }

  const handleBackClick = () => {
    history.push(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}customerrank`);
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!data.expiry && data.receiving_type !== constClass.RECEIVING_TYPE.TICKET_DELIVERY) {
      window.alert('有効期限日を入力してください。');
      return;
    }
    if (!data.lottery_start || !data.lottery_end || moment(data.lottery_start) > moment(data.lottery_end)) {
      window.alert('期間指定が間違っています。');
      return;
    }
    if (data.receiving_type === constClass.RECEIVING_TYPE.POINT && !data.point) {
      window.alert('付与ポイント数を入力してください。');
      return;
    }
    if (data.receiving_type === constClass.RECEIVING_TYPE.POINT && data.point < 0) {
      window.alert('付与ポイント数は0以上で入力してください。');
      return;
    }
    if (data.receiving_type === constClass.RECEIVING_TYPE.POINT && data.distribution_point_mall_flag === constClass.FLAG.OFF && !data.point_mall_id) {
      window.alert('ポイント負担施設を選択してください。');
      return;
    }
    if ((data.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR || data.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON) && !data.ticket_id) {
      window.alert('配布クーポンを選択してください。');
      return;
    }
    if (data.benefit_lottery_ticket_title && data.benefit_lottery_ticket_title.length > 100) {
      window.alert('特典タイトルは50文字以内で入力してください。');
      return;
    }
    if (data.benefit_lottery_ticket_summary && data.benefit_lottery_ticket_summary.length > 200) {
      window.alert('特典概要は200文字以内で入力してください。');
      return;
    }
    var params = { ...data };

    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;
    if (params.receiving_type === constClass.RECEIVING_TYPE.TICKET_DELIVERY) {
      params.expiry = null;
    }
    if (params.uploadfiletype === null) params.uploadfile = null;
    if (params.uploadfiletype2 === null) params.uploadfile2 = null;
    if (params.uploadfiletype3 === null) params.uploadfile3 = null;
    params.shop_group = null;
    if (params.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR && shopGroupON.length > 0) {
      params.shop_group = shopGroupON.map(shop => ({ site_id: siteId, shop_group_id: shop.value, use_flg: constClass.FLAG.ON }));
    } else if (params.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR && shopGroupOFF.length > 0) {
      params.shop_group = shopGroupOFF.map(shop => ({ site_id: siteId, shop_group_id: shop.value, use_flg: constClass.FLAG.OFF }));
    }

    params.lottery_start = moment(data.lottery_start).format('YYYYMMDD');
    params.lottery_end = moment(data.lottery_end).format('YYYYMMDD');
    let res;
    try {
      setLockData(true);
      if (benefitLotteryTicketValues.benefit_lottery_ticket_id) {
        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/${benefitLotteryTicketData.benefit_lottery_ticket_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }

    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      handleResetClick();
      setLockData(false);
    }
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setBenefitLotteryTicketValues({
      benefit_lottery_ticket_id: "",
      lottery_start: null,
      lottery_end: null,
      benefit_lottery_ticket_title: "",
      benefit_lottery_ticket_summary: "",
      benefit_lottery_ticket_detail: "",
      uploadfile: "",
      uploadfiletype: "",
      deletefile: "",
      uploadfile2: "",
      uploadfiletype2: "",
      deletefile2: "",
      uploadfile3: "",
      uploadfiletype3: "",
      deletefile3: "",
      expiry: "",
      limit_count: null,
      min_amount: null,
      receiving_type: constClass.RECEIVING_TYPE.TICKET_DELIVERY,
      point: null,
      distribution_point_mall_flag: constClass.FLAG.OFF,
      point_mall_id: null,
      benefit_lottery_ticket_image_url: "",
      benefit_lottery_ticket_detail_image_url: "",
      notice_lottery_image_url: "",
      notice_title: "",
      notice_alt_text: "",
      notice_detail: "",
      year_month: [],
      ticket_id: null,
      upd_date: "",
    });
    setShopGroupONValues([]);
    setShopGroupOFFValues([]);
  }


  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`ランク特典抽選[${data.benefit_lottery_ticket_id}:${data.benefit_lottery_ticket_title}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      benefit_lottery_ticket_id: data.benefit_lottery_ticket_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const handleChangeShopGroupOFF = (data) => {
    setShopGroupOFFValues(data);
  }

  const handleChangeShopGroupON = (data) => {
    setShopGroupONValues(data);
  }

  const handleChangeFile = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      setBenefitLotteryTicketValues({
        ...benefitLotteryTicketValues,
        uploadfile: reader.result,
        uploadfiletype: value.type,
        deletefile: benefitLotteryTicketValues.benefit_lottery_ticket_image_url
      });
    }
    reader.readAsDataURL(value);
  }

  const handleChangeFile2 = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      setBenefitLotteryTicketValues({
        ...benefitLotteryTicketValues,
        uploadfile2: reader.result,
        uploadfiletype2: value.type,
        deletefile2: benefitLotteryTicketValues.benefit_lottery_ticket_detail_image_url
      });
    }
    reader.readAsDataURL(value);
  }

  const handleChangeFile3 = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      setBenefitLotteryTicketValues({
        ...benefitLotteryTicketValues,
        uploadfile3: reader.result,
        uploadfiletype3: value.type,
        deletefile3: benefitLotteryTicketValues.notice_lottery_image_url
      });
    }
    reader.readAsDataURL(value);
  }


  /* 編集ボタン押下 */
  const handleUpdateClick = async (data) => {
    var temp = { ...data };
    temp.deletefile = null;
    temp.uploadfiletype = null;
    temp.deletefile2 = null;
    temp.uploadfiletype2 = null;
    temp.deletefile3 = null;
    temp.uploadfiletype3 = null;
    if (data.benefit_lottery_ticket_image_url != null) temp.uploadfile = `/${siteId}/${constClass.BENEFIT_LOTTERY_TICKET_IMAGE_DIR + data.benefit_lottery_ticket_image_url}`;
    else temp.uploadfile = null;
    if (data.benefit_lottery_ticket_detail_image_url != null) temp.uploadfile2 = `/${siteId}/${constClass.BENEFIT_LOTTERY_TICKET_DETAIL_IMAGE_DIR + data.benefit_lottery_ticket_detail_image_url}`;
    else temp.uploadfile2 = null;
    if (data.notice_lottery_image_url != null) temp.uploadfile3 = `/${siteId}/${constClass.NOTICE_LOTTERY_IMAGE_DIR + data.notice_lottery_image_url}`;
    else temp.uploadfile3 = null;
    temp.year_month = data.m_benefit_lottery_ticket_yearmonth ? data.m_benefit_lottery_ticket_yearmonth.map(ym => ym.year_month) : [];
    const shopGroupONValues = data.m_benefit_lottery_ticket_shop_group
      ? data.m_benefit_lottery_ticket_shop_group.filter(a => a.use_flg === constClass.FLAG.ON)
        .map(a => ({ value: a.shop_group_id, label: shopGroupMaster.find(x => x.value === a.shop_group_id).label }))
      : [];

    const shopGroupOFFValues = data.m_benefit_lottery_ticket_shop_group
      ? data.m_benefit_lottery_ticket_shop_group.filter(a => a.use_flg === constClass.FLAG.OFF)
        .map(a => ({ value: a.shop_group_id, label: shopGroupMaster.find(x => x.value === a.shop_group_id).label }))
      : [];

    if (shopGroupONValues.length > 0) {
      setShopGroupONValues(shopGroupONValues);
    } else if (shopGroupOFFValues.length > 0) {
      setShopGroupOFFValues(shopGroupOFFValues);
    }
    temp.push_datetime = temp.push_datetime ? new Date(moment(temp.push_datetime).format('YYYY/MM/DD HH:mm')) : null;

    temp.lottery_start = temp.lottery_start ? moment(temp.lottery_start, 'YYYYMMDD').toDate() : null;
    temp.lottery_end = temp.lottery_end ? moment(temp.lottery_end, 'YYYYMMDD').toDate() : null;

    setBenefitLotteryTicketValues(temp);
  }

  const setDateValue = (value, name) => {
    setBenefitLotteryTicketValues({ ...benefitLotteryTicketValues, [name]: value });
  }

  const handleDeleteFile = () => {
    setBenefitLotteryTicketValues({ ...benefitLotteryTicketValues, uploadfile: null, uploadfiletype: null, deletefile: benefitLotteryTicketValues.benefit_lottery_ticket_image_url });
  }

  const handleDeleteFile2 = () => {
    setBenefitLotteryTicketValues({ ...benefitLotteryTicketValues, uploadfile2: null, uploadfiletype2: null, deletefile2: benefitLotteryTicketValues.benefit_lottery_ticket_detail_image_url });
  }

  const handleDeleteFile3 = () => {
    setBenefitLotteryTicketValues({ ...benefitLotteryTicketValues, uploadfile3: null, uploadfiletype3: null, deletefile3: benefitLotteryTicketValues.notice_lottery_image_url });
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.benefit_lottery_ticket_title === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || !data.benefit_lottery_ticket_id}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const handleChangeDate = (name, value) => {
    setBenefitLotteryTicketValues({ ...benefitLotteryTicketValues, [name]: value });
  }

  return (
    <React.Fragment>
      <div className="container">
        <div className="row mx-0 my-2 mt-2 px-1-env">
          <div className="row col-12 mt-2 mb-2">
            <div className='col-2'>
              <button type="button"
                className={`btn btn-secondary mx-1 w-100 text-nowrap`}
                onClick={() => { handleBackClick() }}>
                戻る
              </button>
            </div>
          </div>
        </div>
        <div className="row mb-3 p-0">
          <div className="col-12 p-0">
            <table className="table table-bordered table-striped">
              <thead className={`table-info`}>
                <tr>
                  <td className="text-center align-middle">
                    特典抽選ID
                  </td>
                  <td className="text-center align-middle">
                    特典タイトル
                  </td>
                  <td className="text-center align-middle">
                    処理
                  </td>
                </tr>
              </thead>
              <tbody>
                {benefitLotteryTicketData && benefitLotteryTicketData.length > 0 && benefitLotteryTicketData.map((data, idx) => (
                  <tr key={idx}>
                    {/* 特典抽選ID */}
                    <td className="text-center align-middle">
                      {data.benefit_lottery_ticket_id}
                    </td>
                    {/* 特典タイトル */}
                    <td className="text-center align-middle">
                      {data.benefit_lottery_ticket_title}
                    </td>
                    {/* 処理 */}
                    <td className="text-center align-middle text-nowrap">
                      {renderUpdateButton(data)}
                    </td>
                  </tr>
                ))
                }
              </tbody>
            </table>
          </div>
        </div>
        <div className="mx-1">
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <span>特典抽選ID</span>
            </div>
            <div className="col-2 text-center align-self-center">
              <input type="text" className="form-control" name="benefit_lottery_ticket_id" defaultValue={benefitLotteryTicketValues.benefit_lottery_ticket_id} placeholder="新規" readOnly />
            </div>
          </div>
          <div className="row my-3">
            <div className="col-2 text-center align-self-center">
              <span>抽選期間</span>
            </div>
            <div className="col-4 text-center">
              <DatePicker className="custom-select text-left"
                locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'lottery_start'} name={'lottery_start'}
                popperPlacement='bottom'
                selected={benefitLotteryTicketValues && benefitLotteryTicketValues.lottery_start ? benefitLotteryTicketValues.lottery_start : null}
                onChange={(value) => setDateValue(value, "lottery_start")}
                placeholderText="- 選択 -"
                autoComplete='off'
                isClearable={true}
                onFocus={(e) => e.target.blur()}
              />
            </div>
            <div className="col-1 text-center">～</div>
            <div className="col-4 text-center">
              <DatePicker className="custom-select text-left"
                locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'lottery_end'} name={'lottery_end'}
                popperPlacement='bottom'
                selected={benefitLotteryTicketValues && benefitLotteryTicketValues.lottery_end ? benefitLotteryTicketValues.lottery_end : null}
                onChange={(value) => setDateValue(value, "lottery_end")}
                placeholderText="- 選択 -"
                autoComplete='off'
                isClearable={true}
                onFocus={(e) => e.target.blur()}
              />
            </div>
          </div>
          {/* <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="year_month">抽選期間年月</label>
            </div>
            <div className="col-5 align-self-center">
              <CreatableSelect
                isMulti
                name="year_month"
                id="year_month"
                options={yearMonthOptions}
                value={yearMonthOptions.filter(opt => benefitLotteryTicketValues.year_month.includes(opt.value))
                  .concat(
                    benefitLotteryTicketValues.year_month
                      .filter(ym => !yearMonthOptions.some(opt => opt.value === ym))
                      .map(ym => ({ value: ym, label: ym }))
                  )
                }
                onChange={selected => {
                  setBenefitLotteryTicketValues({
                    ...benefitLotteryTicketValues,
                    year_month: selected.map(opt => opt.value)
                  });
                }}
                placeholder="使用年月を選択または追加"
                isClearable
                isSearchable
                closeMenuOnSelect={false}
              />
            </div>
          </div> */}
          {/* <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="year_month">抽選期間年月</label>
            </div>
            <div className="col-5 align-self-center">
              <CreatableSelect
                isMulti
                name="year_month"
                id="year_month"
                options={yearMonthOptions}
                value={yearMonthOptions.filter(opt => benefitLotteryTicketValues.year_month.includes(opt.value))
                  .concat(
                    benefitLotteryTicketValues.year_month
                      .filter(ym => !yearMonthOptions.some(opt => opt.value === ym))
                      .map(ym => ({ value: ym, label: ym }))
                  )
                }
                onChange={selected => {
                  setBenefitLotteryTicketValues({
                    ...benefitLotteryTicketValues,
                    year_month: selected.map(opt => opt.value)
                  });
                }}
                placeholder="使用年月を選択または追加"
                isClearable
                isSearchable
                closeMenuOnSelect={false}
              />
            </div>
          </div> */}
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <span>特典タイトル</span>
            </div>
            <div className="col-5 text-center align-self-center">
              <input type="text" className="form-control" name="benefit_lottery_ticket_title" value={benefitLotteryTicketValues.benefit_lottery_ticket_title} onChange={handleChange} placeholder="特典タイトルを入力してください" />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="benefit_lottery_ticket_summary">特典概要</label>
            </div>
            <div className="col-5 align-self-center">
              <input type="text" className="form-control" name="benefit_lottery_ticket_summary" id="benefit_lottery_ticket_summary" value={benefitLotteryTicketValues.benefit_lottery_ticket_summary || ""} placeholder="特典の概要を入力してください" onChange={handleChange}></input>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="benefit_lottery_ticket_detail">特典詳細</label>
            </div>
            <div className="col-5 align-self-center">
              <textarea className="form-control" rows="3" name="benefit_lottery_ticket_detail" id="benefit_lottery_ticket_detail" value={benefitLotteryTicketValues.benefit_lottery_ticket_detail || ""} onChange={handleChange}></textarea>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="benefit_lottery_ticket_image">特典画像</label>
            </div>
            <div className="col-5 align-self-center">
              {!(benefitLotteryTicketValues.uploadfile) && <input type="file" className="form-control-file" name="benefit_lottery_ticket_image" id="benefit_lottery_ticket_image" value="" onChange={handleChangeFile} onClick={e => (e.target.value = null)} />}
              {benefitLotteryTicketValues.uploadfile && <object id="uploadfileview" className="w-100" data={benefitLotteryTicketValues.uploadfile} type={benefitLotteryTicketValues.uploadfiletype}><img className="w-100" src={benefitLotteryTicketValues.uploadfile} alt='uploadfile' /></object>}
              {benefitLotteryTicketValues.uploadfile && <input type="button" className="form-controll" name="deletefile" id="deletefile" onClick={handleDeleteFile} value="ファイル削除" />}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="benefit_lottery_ticket_detail_image_url">特典詳細画像</label>
            </div>
            <div className="col-5 align-self-center">
              {!(benefitLotteryTicketValues.uploadfile2) && <input type="file" className="form-control-file" name="benefit_lottery_ticket_detail_image_url" id="benefit_lottery_ticket_detail_image_url" value="" onChange={handleChangeFile2} onClick={e => (e.target.value = null)} disabled={!benefitLotteryTicketValues.uploadfile} />}
              {benefitLotteryTicketValues.uploadfile2 && <object id="uploadfileview" className="w-100" data={benefitLotteryTicketValues.uploadfile2} type={benefitLotteryTicketValues.uploadfiletype2}><img className="w-100" src={benefitLotteryTicketValues.uploadfile2} alt='uploadfile2' /></object>}
              {benefitLotteryTicketValues.uploadfile2 && <input type="button" className="form-controll" name="deletefile2" id="deletefile2" onClick={handleDeleteFile2} value="ファイル削除" />}
            </div>
            <div className="col-5 text-left align-self-center">
              特典詳細画面に表示される画像です。<br />設定しない場合は、特典一覧画像が詳細画面にも表示されます。
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="receiving_type">受け取り区分</label>
            </div>
            <div className="col-3">
              <select className="form-control" id="receiving_type" name="receiving_type" value={benefitLotteryTicketValues.receiving_type} onChange={handleChange}>
                <option key={constClass.RECEIVING_TYPE_NAME.TICKET_DELIVERY} value={constClass.RECEIVING_TYPE.TICKET_DELIVERY}>{constClass.RECEIVING_TYPE_NAME.TICKET_DELIVERY}</option>
                <option key={constClass.RECEIVING_TYPE_NAME.DIGITAL_TICKET_QR} value={constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR}>{constClass.RECEIVING_TYPE_NAME.DIGITAL_TICKET_QR}</option>
                <option key={constClass.RECEIVING_TYPE_NAME.DIGITAL_TICKET_BUTTON} value={constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON}>{constClass.RECEIVING_TYPE_NAME.DIGITAL_TICKET_BUTTON}</option>
                <option key={constClass.RECEIVING_TYPE_NAME.POINT} value={constClass.RECEIVING_TYPE.POINT}>{constClass.RECEIVING_TYPE_NAME.POINT}</option>
              </select>
            </div>
          </div>
          {(benefitLotteryTicketValues.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR || benefitLotteryTicketValues.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON) &&
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="ticket_id">配布クーポン</label>
              </div>
              <div className="col-5 align-self-center">
                <select className="form-control" id="ticket_id" name="ticket_id" value={benefitLotteryTicketValues.ticket_id || ''} onChange={handleChange}>
                  <option value="">- 選択 -</option>
                  {ticketData && ticketData.map((ticket) => (
                    <option key={ticket.ticket_id} value={ticket.ticket_id}>
                      {ticket.ticket_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          }
          {benefitLotteryTicketValues.receiving_type === constClass.RECEIVING_TYPE.POINT &&
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <span>付与ポイント</span>
              </div>
              <div className="col-5 text-center align-self-center">
                <input type="text" className="form-control" name="point" value={benefitLotteryTicketValues.point || ''} onChange={handleChange} placeholder="付与ポイントを入力してください" />
              </div>
            </div>
          }
          {benefitLotteryTicketValues.receiving_type === constClass.RECEIVING_TYPE.POINT &&
            <React.Fragment>
              <div className="row mb-3">
                <div className="col-2 text-center align-self-center">
                  <span>付与ポイント負担施設</span>
                </div>
                <div className="col-5 text-center align-self-center">
                  <select className="form-control" id="point_mall_id" name="point_mall_id" value={benefitLotteryTicketValues.point_mall_id || ''} onChange={handleChange} disabled={benefitLotteryTicketValues.distribution_point_mall_flag === constClass.FLAG.ON}>
                    <option value="">- 選択 -</option>
                    {mallData && mallData.map((mall) => (
                      <option key={mall.mall_id} value={mall.mall_id}>
                        {mall.mall_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-2 text-center align-self-center">
                  <span>付与ポイント負担施設按分フラグ</span>
                </div>
                <div className="col-5 text-left align-self-center">
                  <input type="checkbox" className="form-control w-25" id="distribution_point_mall_flag" name="distribution_point_mall_flag" value="true" checked={benefitLotteryTicketValues.distribution_point_mall_flag === constClass.FLAG.ON} onChange={handleChange}></input>
                </div>
                {benefitLotteryTicketValues.receiving_type === constClass.RECEIVING_TYPE.POINT &&
                  <div className="col-5 text-left align-self-center">
                    按分フラグにチェックが入っている場合、負担は各施設に分担されます。
                    割り切れない場合は、端数はワンビルの負担としてポイントが付与されます。
                  </div>
                }
              </div>
            </React.Fragment>
          }
          {benefitLotteryTicketValues.receiving_type !== constClass.RECEIVING_TYPE.TICKET_DELIVERY &&
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="expiry">有効期限（付与日から〇日間）</label>
              </div>
              <div className="col-4 pt-1 text-center">
                <input type="text" className="form-control" name="expiry" value={benefitLotteryTicketValues.expiry} onChange={handleChange} placeholder="有効期限を入力してください" />
              </div>
            </div>
          }
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="limit_count">当選最大数</label>
            </div>
            <div className="col-5 align-self-center">
              <input type="text" className="form-control" name="limit_count" id="limit_count" value={benefitLotteryTicketValues.limit_count || ''} placeholder="当選最大数を入力してください" onChange={handleChange}></input>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="min_amount">〇〇円以上ご購入で抽選対象</label>
            </div>
            <div className="col-5 align-self-center">
              <input type="text" className="form-control" name="min_amount" id="min_amount" value={benefitLotteryTicketValues.min_amount || ''} placeholder="購入金額を入力してください" onChange={handleChange}></input>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <span>当選送信日時</span>
            </div>
            <div className="col-5">
              <DatePicker className="custom-select text-left border-textbox"
                aria_labal="送信日時" locale="ja" dateFormat="yyyy/MM/dd HH:mm" monthsShown="1" id="push_datetime" name="push_datetime"
                popperPlacement='right'
                showTimeSelect
                selected={benefitLotteryTicketValues.push_datetime ? benefitLotteryTicketValues.push_datetime : null}
                onChange={benefitLotteryTicketValues => handleChangeDate("push_datetime", benefitLotteryTicketValues)}
                placeholderText="- 選択 -"
              />
            </div>
          </div>
          {benefitLotteryTicketValues.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR && (
            <React.Fragment>
              {shopGroupON.length === 0 && (
                <div className="row mb-3">
                  <div className="col-2 text-center align-self-center">
                    <label htmlFor="use_flg">利用不可店舗グループ</label>
                  </div>
                  <div className="col-5 align-self-center">
                    <Select options={shopGroupMaster} isMulti closeMenuOnSelect={false} value={shopGroupOFF} onChange={handleChangeShopGroupOFF} placeholder="クーポンを利用できない店舗グループ" />
                  </div>
                </div>
              )}
              {shopGroupOFF.length === 0 && (
                <div className="row mb-3">
                  <div className="col-2 text-center align-self-center">
                    <label htmlFor="use_flg">利用可能店舗グループ</label>
                  </div>
                  <div className="col-5 text-center align-self-center">
                    <Select options={shopGroupMaster} isMulti closeMenuOnSelect={false} value={shopGroupON} onChange={handleChangeShopGroupON} placeholder="クーポンを利用できる店舗グループ" />
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
          <div className="notice-margin">
            <div className="col-12 mb-3 text-center align-self-center">
              設定しない場合は、システムであらかじめ用意された当選時タイトル、当選時テキスト、当選時詳細、当選時画像が表示されます。
            </div>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="notice_title">当選時タイトル</label>
              </div>
              <div className="col-5 align-self-center">
                <input type="text" className="form-control" name="notice_title" id="notice_title" value={benefitLotteryTicketValues.notice_title || ""} placeholder="当選時のタイトル" onChange={handleChange} />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="notice_alt_text">当選時テキスト</label>
              </div>
              <div className="col-5 align-self-center">
                <input type="text" className="form-control" name="notice_alt_text" id="notice_alt_text" value={benefitLotteryTicketValues.notice_alt_text || ""} placeholder="当選時のテキスト" onChange={handleChange} />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="notice_detail">当選時詳細</label>
              </div>
              <div className="col-5 align-self-center">
                <textarea className="form-control" rows="2" name="notice_detail" id="notice_detail" value={benefitLotteryTicketValues.notice_detail || ""} placeholder="当選時の詳細" onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="notice_lottery_image_url">当選時画像</label>
              </div>
              <div className="col-5 align-self-center">
                {!(benefitLotteryTicketValues.uploadfile3) && <input type="file" className="form-control-file" name="notice_lottery_image_url" id="notice_lottery_image_url" value="" onChange={handleChangeFile3} onClick={e => (e.target.value = null)} />}
                {benefitLotteryTicketValues.uploadfile3 && <object id="uploadfileview3" className="w-100" data={benefitLotteryTicketValues.uploadfile3} type={benefitLotteryTicketValues.uploadfiletype3}><img className="w-100" src={benefitLotteryTicketValues.uploadfile3} alt='uploadfile3' /></object>}
                {benefitLotteryTicketValues.uploadfile3 && <input type="button" className="form-controll" name="deletefile3" id="deletefile3" onClick={handleDeleteFile3} value="ファイル削除" />}
              </div>
            </div>
          </div>
          <div className="row mb-2 pb-4">
            <div className="col-3 text-center">
              {renderRegistButton(benefitLotteryTicketValues)}
            </div>
            <div className="col-3 text-center">
              {renderDeleteButton(benefitLotteryTicketValues)}
            </div>
            <div className="col-3 text-center">
              {renderResetButton(benefitLotteryTicketValues)}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment >
  );
}

export default BenefitLotteryTicket;